<template>
  <div
    v-b-popover.hover.topright="'+ Change bonus '"
    class="hover-pointer"
    @click="addBonus(dataBonus.item.id)"
  >
    {{ dataBonus.item.bonus }}
  </div>
</template>

<script>
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  name: 'AddBonus',
  props: {
    dataBonus: {
      type: Object,
      required: false,
      default: null,
    },
    getAllDataPass: {
      type: Function,
      required: true,
    },
  },
  methods: {
    addBonus(id) {
      this.$swal.fire({
        title: 'Add Bonus',
        input: 'number',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Add',
        showLoaderOnConfirm: true,
        preConfirm: async inputValue => {
          try {
            const url = `/payslip/${id}/bonus`
            const response = await axios.patch(url, { bonus: inputValue })
            return response.data || { success: true }
          } catch (error) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.$swal.showValidationMessage(
              `${errorMessage}`,
            )
            return false
          }
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      }).then(result => {
        if (result.isConfirmed) {
          this.$swal.fire({
            title: 'Added successfully',
            icon: 'success',
          })
          this.getAllDataPass()
        }
      })
    },
  },
}
</script>
